import React, { Component } from 'react'
import YouTube from 'react-youtube'
import PropTypes from 'prop-types'

class YouTubePlayer extends Component {
  static propTypes = {
    videoId: PropTypes.string.isRequired
  }

  state = {
    videoId: null,
    player: null,
    opts: {
      playerVars: {
        rel: 0,
        autoplay: 0
      },
    }
  }

  componentDidMount() {
    let { videoId } = this.props

    this.setState(state => ({
      ...state,
      videoId
    }))
  }

  componentWillReceiveProps(props) {
    this.setState({ videoId: props.videoId });
  }

  onReady = (event) => {
    this.setState(state => ({
      ...state,
      player: event.target
    }))
  }

  onPlayVideo = () => {
    this.state.player.playVideo()
  }

  pauseVideoPlayback = () => {
    this.state.player.pauseVideo()
  }

  render() {
    const { videoId, opts } = this.state

    return (
      <div className="youtube-player">
        <YouTube
          videoId={videoId}
          onReady={this.onReady}
          onPlay={this.onPlayVideo}
          onPause={this.pauseVideoPlayback}
          opts={opts}
        />
      </div>
    )
  }
}

export default YouTubePlayer



// WEBPACK FOOTER //
// ./src/components/Global/YouTubePlayer.js